import Headings from './Headings/Headings';
import ScrollToTop from './ScrollToTop/ScrollToTop';
import CookieBanner from './CookieBanner/CookieBanner';

export{
    Headings, ScrollToTop, CookieBanner,
}
